import { store } from '../redux/store';

export type SentryUserContext = {
  user?: { id: string };
  user_role?: string;
  network_id?: string;
  grade_level_id?: string;
  site_0?: string;
  site_1?: string;
  site_2?: string;
};

export function getSentryUserContext(): SentryUserContext {
  const user = store.getState().user.value;

  const auth0Id = user?.sub ?? '';
  const role = user?.roles?.[0]?.name ?? '';
  const networkId = user?.network?.id ?? '';
  const gradeLevelId = user?.gradeLevel?.id ?? '';
  const siteIds = user?.sites?.map((s: { id: string }) => s.id).slice(0, 3) ?? [];

  return {
    ...(auth0Id && { user: { id: auth0Id } }),
    ...(role && { user_role: role }),
    ...(networkId && { network_id: networkId }),
    ...(gradeLevelId && { grade_level_id: gradeLevelId }),
    ...(siteIds[0] && { site_0: siteIds[0] }),
    ...(siteIds[1] && { site_1: siteIds[1] }),
    ...(siteIds[2] && { site_2: siteIds[2] }),
  };
}
